var ph_doing_shortlist_request = false;
jQuery(document).ready(function()
{
    jQuery('html,body').on('click', 'a[data-add-to-shortlist]', function(e)
    {
        e.preventDefault();

        if ( ph_doing_shortlist_request )
        {
            return;
        }

        ph_doing_shortlist_request = true;

        var property_id = jQuery(this).attr('data-add-to-shortlist');

        jQuery('a[data-add-to-shortlist=\'' + property_id + '\']').toggleClass('loading').attr('disabled', 'disabled');

        var data = {
            action: 'add_to_shortlist',
            property_id: property_id
        };

        jQuery.post(
            propertyhive_shortlist.ajax_url,
            data,
            function(response)
            {
                console.log(response);
                console.log(property_id);

                if ( response.success )
                {
                    if ( response.action == 'added' )
                    {
                        jQuery('a[data-add-to-shortlist=\'' + property_id + '\']').html(propertyhive_shortlist.remove_link_text);
                        jQuery( document ).trigger('ph:added_to_shortlist', [ property_id ]);
                    }
                    else if ( response.action == 'removed' )
                    {
                        jQuery('a[data-add-to-shortlist=\'' + property_id + '\']').html(propertyhive_shortlist.add_link_text);
                        jQuery( document ).trigger('ph:removed_From_shortlist', [ property_id ]);
                    }
                }
                else
                {
                    alert('An error occured when trying to add this property to your shortlist. Please try again.');
                    console.log(response);
                    jQuery( document ).trigger('ph:shortlist_error', [ response, property_id ]);
                }

                jQuery('a[data-add-to-shortlist=\'' + property_id + '\']').toggleClass('loading').attr('disabled', false);

                ph_doing_shortlist_request = false;
            }
        );
    });

    ph_check_if_shortlisted();
});

function ph_check_if_shortlisted()
{
    var property_ids = [];
    jQuery('a[data-add-to-shortlist]').each(function()
    {
        var property_id = jQuery(this).attr('data-add-to-shortlist');
        property_ids.push(property_id);
    });

    if ( property_ids.length > 0 )
    {
        var data = {
            action: 'check_if_shortlisted',
            property_ids: property_ids,
        };

        jQuery.post(
            propertyhive_shortlist.ajax_url,
            data,
            function(response)
            {
                if ( response.success && response.on_shortlist )
                {
                    jQuery.each(response.on_shortlist, function(property_id, value)
                    {
                        var current_text = jQuery('a[data-add-to-shortlist="' + property_id + '"]').text();
                        var this_button = jQuery('a[data-add-to-shortlist="' + property_id + '"]');

                        if ( value )
                        {
                            var correct_button_text = propertyhive_shortlist.remove_link_text;
                        }
                        else
                        {
                            var correct_button_text = propertyhive_shortlist.add_link_text;
                        }

                        if ( current_text != correct_button_text )
                        {
                            this_button.html(correct_button_text);
                        }
                        else
                        {

                        }
                    });
                }
            }
        );
    };
}